@if ((hasCopyConfigStarted$ | async) === false && hasPartialCopyConfigPermission()) {
  <section class="container" data-qa-id="copyconfig-section-options">
    <div class="header-wrapper">
      <h1 data-qa-id="copyconfig-header-title">Copy Configuration</h1>
    </div>
    <div class="content-wrapper">
      <div class="copy-config-options-control">
        <label class="control-label" id="copyConfigOptionsRadioLabel">Choose a copy config process option:</label>
        <mat-radio-group [(ngModel)]="copyConfigOption" aria-labelledby="copyConfigOptionsRadioLabel"
          class="radio-cards-container" data-qa-id="copyconfig-radio-group-options">
          @for (option of copyConfigOptions; track option) {
            <app-radio-button-card [value]="option.value" [label]="option.label"
              [icon]="option.icon" [checked]="option.value === copyConfigOption"
              [class.checked]="option.value === copyConfigOption"
              [attr.data-qa-id]="'copyconfig-radio-option-' + option.value">
              <div class="description">
                <div class="description-title">{{ option.shortDescription }}</div>
                <div class="card-info">
                  <mat-icon [class]="option.descriptionIcon">{{ option.descriptionIcon }}</mat-icon>
                  <div>{{ option.info }}</div>
                </div>
              </div>
            </app-radio-button-card>
          }
        </mat-radio-group>
      </div>
    </div>
  </section>
}

<section class="container" data-qa-id="copyconfig-section-main">
  <div class="header-wrapper">
    <h1 data-qa-id="copyconfig-header-selected-option">Copy Configuration @if (hasPartialCopyConfigPermission()) {
      <span>Options - {{ getCopyConfigSelectedOptionName()
      }}</span>
    }</h1>
  </div>
  <div class="content-wrapper">
    @if ((copyConfigInProgress$ | async)) {
      <div class="console-container" data-qa-id="copyconfig-progress-container">
        <div class="console-header">
          <div class="console-title">Progress</div>
        </div>
        @if ((copyConfigJobId$ | async); as copyConfigJobId) {
          <job-liveview [jobId]="copyConfigJobId"
            (finished)="jobComplete($event)" data-qa-id="copyconfig-job-liveview">
          </job-liveview>
        }
      </div>
    } @else {
      @switch (copyConfigOption) {
        @case ('ExportImport') {
          <app-copy-config-export-import data-qa-id="copyconfig-form-export-import"></app-copy-config-export-import>
        }
        @case ('Export') {
          <app-copy-config-export-only data-qa-id="copyconfig-form-export-only"></app-copy-config-export-only>
        }
        @case ('Import') {
          <app-copy-config-import-only data-qa-id="copyconfig-form-import-only"></app-copy-config-import-only>
        }
      }
    }
  </div>
</section>